import styled from "styled-components";

interface FootContainerProps {
  centerFlex: boolean;
}

export const FooterContainer = styled.div<FootContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${({centerFlex}) => centerFlex ? 'center' : 'space-between'};
  align-items: center;
`;

export const EmptyDiv = styled.div`
  width: 92px;
`;
